import React from "react"

import './PostStatusFilter.css'

export default class PostStatusFilter extends React.Component {
    constructor(props) {
        super(props)
        this.buttons = [
            {
                name: 'all', label: 'All'
            },
            {
                name: 'liked', label: 'Liked'
            }
        ]
    }

    render() {
        const { filter, onFilterSelect } = this.props
        const buttons = this.buttons.map(({ name, label }) => {
            const active = filter === name
            const clazz = active ? 'btn-success filters': 'btn-outline-danger'
            return (
                <button
                    key={ name }
                    type="button"
                    className={`btn ${clazz}`}
                    onClick={ () => onFilterSelect(name) }
                >
                    { label }
                </button>
                )
            })

        return (
            <div className="btn-group">
                { buttons }
            </div>
        )
    }
}








